import {
	DeleteOutlined,
	EditOutlined,
	PlusOutlined,
	AppstoreOutlined,
	FilterOutlined,
	ReloadOutlined,
	LinkOutlined,
	CopyOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Flex, Input, Modal, Select, Space, Table, Tag, Tooltip, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';
import categoryApi from '../../api/category';
import pagesApi from '../../api/page';
import SH_Toolbar from '../../components/SH_Toolbar';
import TV_page_detail from './TV_page_detail';
import PageSectionLinkPremium from '../../components/pageSectionLinkPremium';

const LANDING_PAGE_URL = process.env.REACT_APP_LANDING_PAGE_URL || 'http://localhost:3000';

const TEMPLATE_OPTIONS = [
	{ label: 'Tất cả loại trang', value: undefined },
	{ label: 'Trang dịch vụ', value: 'SERVICE' },
	{ label: 'Trang dự án', value: 'PROJECT' },
	{ label: 'Danh sách tin tức', value: 'NEWS_LIST' },
	{ label: 'Danh sách sản phẩm', value: 'PRODUCT_LIST' },
	{ label: 'Nhóm sản phẩm', value: 'PRODUCT_GROUP' },
];

const TEMPLATE_LABEL = {
	SERVICE: 'Trang dịch vụ',
	PROJECT: 'Trang dự án',
	NEWS_LIST: 'Danh sách tin tức',
	PRODUCT_LIST: 'Danh sách sản phẩm',
	PRODUCT_GROUP: 'Nhóm sản phẩm',
};

const TEMPLATE_OPTIONS_UI = [
	{ label: 'Trang dịch vụ', value: 'SERVICE' },
	{ label: 'Trang dự án', value: 'PROJECT' },
	{ label: 'Danh sách tin tức', value: 'NEWS_LIST' },
	{ label: 'Danh sách sản phẩm', value: 'PRODUCT_LIST' },
	{ label: 'Nhóm sản phẩm', value: 'PRODUCT_GROUP' },
];

const renderTypeTag = (type) => (
	<Tooltip title={type}>
		<Tag color={getTypeTagColor(type)} style={{ marginRight: 0, borderRadius: 999 }}>
			{TEMPLATE_LABEL[type] || type}
		</Tag>
	</Tooltip>
);

const getTypeTagColor = (type) => {
	const map = {
		SERVICE: 'magenta',
		PROJECT: 'volcano',
		NEWS_LIST: 'geekblue',
		PRODUCT_LIST: 'blue',
		PRODUCT_GROUP: 'purple',
	};

	return map[type] || 'blue';
};

const ENABLED_OPTIONS = [
	{ label: 'Tất cả', value: undefined },
	{ label: 'Đang bật', value: true },
	{ label: 'Đang tắt', value: false },
];

const CREATED_AT_SORT_OPTIONS = [
	{ label: 'Mặc định', value: 0 },
	{ label: 'Mới nhất', value: -1 },
	{ label: 'Cũ nhất', value: 1 },
];

const buildDemoUrl = (base, path) => {
	const baseNorm = String(base || '').replace(/\/+$/, '');
	const p = String(path || '').trim();
	if (!p) return baseNorm || '';
	const pathNorm = p.startsWith('/') ? p : `/${p}`;
	return encodeURI(`${baseNorm}${pathNorm}`);
};

const copyToClipboard = async (text, okMsg = 'Đã copy') => {
	const t = String(text || '').trim();
	if (!t) return;

	try {
		if (navigator?.clipboard?.writeText) {
			await navigator.clipboard.writeText(t);
		} else {
			const el = document.createElement('textarea');
			el.value = t;
			el.setAttribute('readonly', '');
			el.style.position = 'absolute';
			el.style.left = '-9999px';
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		}
		message.success(okMsg);
	} catch {
		message.error('Copy thất bại');
	}
};

const TV_page = () => {
	const refLink = useRef();
	const refDetail = useRef();

	const [dictionary, setDictionary] = useState({ categories: [] });
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [total, setTotal] = useState(0);

	const [filter, setFilter] = useState({
		page: 1,
		limit: 10,
		search: '',
		enabled: undefined, // boolean | undefined
		template: undefined, // enum | undefined
		createdAt: 0, // -1 | 0 | 1
		// sort: -1,
	});

	useEffect(() => {
		getProducts(filter);
		getCategory().then((r) => r);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCategory = async () => {
		setLoading(true);
		try {
			const [categories] = await Promise.all([
				categoryApi.get({
					page: 1,
					limit: 9999,
				}),
			]);
			setDictionary({
				categories: categories?.data?.data?.items?.map((x) => ({ ...x, label: x?.names?.vi })) || [],
			});
		} finally {
			setLoading(false);
		}
	};

	const getProducts = (_filter = filter) => {
		setLoading(true);
		pagesApi
			.get({
				..._filter,
				page: _filter?.page || 1,
				limit: _filter?.limit || 10,
			})
			.then((res) => {
				setProducts(res?.data?.data?.items || []);
				setTotal(res?.data?.data?.pagination?.total || 0);
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	const conFirm = (event) => {
		return Modal.confirm({
			title: 'Xác nhận xóa',
			content: 'Bạn có chắc chắn muốn xóa bản ghi này không ? ',
			okText: 'Xóa',
			cancelText: 'Hủy',
			okButtonProps: { danger: true },
			onOk: () => deleteItem(event),
			footer: (_, { OkBtn, CancelBtn }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			),
		});
	};

	const deleteItem = (event) => {
		setLoading(true);
		pagesApi.delete(event._id).then(() => {
			setLoading(false);
			getProducts(filter);
		});
	};

	const showModal = () => refDetail.current.create();

	const handlePageChange = (page, pageSize) => {
		const next = { ...filter, page, limit: pageSize };
		setFilter(next);
		getProducts(next);
	};

	const resetFilter = () => {
		const next = {
			page: 1,
			limit: filter.limit,
			search: '',
			enabled: undefined,
			template: undefined,
			createdAt: 0,
		};
		setFilter(next);
		getProducts(next);
	};

	const templateTagColor = (tpl) => {
		switch (tpl) {
			case 'SERVICE':
				return 'blue';
			case 'PROJECT':
				return 'geekblue';
			case 'NEWS_LIST':
				return 'purple';
			case 'PRODUCT_LIST':
				return 'green';
			case 'PRODUCT_GROUP':
				return 'volcano';
			default:
				return 'default';
		}
	};

	const openDemo = (record) => {
		const url = buildDemoUrl(LANDING_PAGE_URL, record?.path);
		if (!url) return;
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	const columns = useMemo(
		() => [
			{
				title: 'Tên trang (VI)',
				dataIndex: 'names',
				key: 'names_vi',
				ellipsis: true,
				render: (text) => (
					<Tooltip title={text?.vi}>
						{text?.vi}{' '}
						<Button
							style={{
								marginLeft: 4,
							}}
							size="small"
							type="text"
							icon={<CopyOutlined />}
							onClick={() => copyToClipboard(text?.vi, 'Đã copy name')}
						/>
					</Tooltip>
				),
			},
			{
				title: 'Tên trang (EN)',
				dataIndex: 'names',
				key: 'names_en',
				ellipsis: true,
				render: (text) => (
					<Tooltip title={text?.en}>
						{text?.en}{' '}
						<Button
							style={{
								marginLeft: 4,
							}}
							size="small"
							type="text"
							icon={<CopyOutlined />}
							onClick={() => copyToClipboard(text?.en, 'Đã copy name')}
						/>
					</Tooltip>
				),
			},
			{
				title: 'Path',
				dataIndex: 'path',
				key: 'path',
				ellipsis: true,
				render: (path) => (
					<Tooltip title={path}>
						<Tag style={{ marginRight: 0 }}>{path || '-'}</Tag>
						<Button
							style={{
								marginLeft: 4,
							}}
							size="small"
							type="text"
							icon={<CopyOutlined />}
							onClick={() => copyToClipboard(path, 'Đã copy path')}
						/>
					</Tooltip>
				),
			},
			{
				title: 'Template',
				dataIndex: 'template',
				key: 'template',
				width: 140,
				render: (template) =>
					template ? (
						renderTypeTag(template)
					) : (
						<Tag color={templateTagColor(template)}>{template || '-'}</Tag>
					),
			},
			{
				title: 'Trạng thái',
				dataIndex: 'enabled',
				key: 'enabled',
				width: 120,
				render: (enabled) => (enabled ? <Tag color="green">Bật</Tag> : <Tag color="red">Tắt</Tag>),
			},
			{
				title: 'Ngày tạo',
				dataIndex: 'createdAt',
				key: 'createdAt',
				width: 190,
				render: (createdAt) => <span>{createdAt ? dayjs(createdAt).format('HH:mm A DD/MM/YYYY') : ''}</span>,
				sorter: (a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf(),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Thao tác',
				key: 'action',
				width: 360,
				render: (_, record) => (
					<Space size="middle" wrap>
						<Button onClick={() => refDetail.current.update(record)} icon={<EditOutlined />}>
							Sửa
						</Button>

						<Button
							type="primary"
							icon={<LinkOutlined />}
							onClick={() => openDemo(record)}
							title="Mở landing page + path"
						>
							Demo
						</Button>

						<Button onClick={() => refLink.current?.open(record)} icon={<AppstoreOutlined />}>
							Quản lý khối nội dung
						</Button>

						<Button onClick={() => conFirm(record)} type="dashed" danger icon={<DeleteOutlined />}>
							Xoá
						</Button>
					</Space>
				),
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const filterDropdown = (
		<div style={{ width: 340 }} className="bg-white p-4 rounded-xl">
			<div style={{ fontWeight: 600, marginBottom: 10 }}>Bộ lọc</div>

			<div style={{ marginBottom: 12 }}>
				<div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Template</div>
				<Select
					style={{ width: '100%' }}
					value={filter.template}
					options={TEMPLATE_OPTIONS}
					onChange={(val) => {
						const next = { ...filter, template: val, page: 1 };
						setFilter(next);
						getProducts(next);
					}}
					placeholder="Chọn template"
					allowClear
				/>
			</div>

			<div style={{ marginBottom: 12 }}>
				<div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Trạng thái</div>
				<Select
					style={{ width: '100%' }}
					value={filter.enabled}
					options={ENABLED_OPTIONS}
					onChange={(val) => {
						const next = { ...filter, enabled: val, page: 1 };
						setFilter(next);
						getProducts(next);
					}}
					placeholder="Chọn trạng thái"
					allowClear
				/>
			</div>

			<div style={{ marginBottom: 12 }}>
				<div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Sắp xếp theo ngày tạo</div>
				<Select
					style={{ width: '100%' }}
					value={filter.createdAt}
					options={CREATED_AT_SORT_OPTIONS}
					onChange={(val) => {
						// backend: createdAt = -1/0/1
						const next = { ...filter, createdAt: val, page: 1 };
						setFilter(next);
						getProducts(next);
					}}
				/>
			</div>

			<Flex justify="space-between" gap={8}>
				<Button icon={<ReloadOutlined />} onClick={resetFilter} style={{ width: '48%' }}>
					Reset
				</Button>
				<Button
					type="primary"
					icon={<FilterOutlined />}
					onClick={() => getProducts({ ...filter, page: 1 })}
					style={{ width: '48%' }}
				>
					Áp dụng
				</Button>
			</Flex>
		</div>
	);

	return (
		<>
			<Flex
				align="center"
				justify="space-between"
				wrap="wrap"
				gap={12}
				style={{
					marginBottom: 12,
				}}
			>
				<Title level={2} style={{ margin: 0 }}>
					Trang
				</Title>
			</Flex>

			<SH_Toolbar
				left={() => (
					<Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
						Thêm trang
					</Button>
				)}
				right={() => (
					<Flex align="center" gap={8}>
						<Input.Search
							allowClear
							style={{ width: 260 }}
							placeholder="Tìm theo tên / path"
							value={filter.search}
							onChange={(e) => {
								const val = e.target.value;
								const next = { ...filter, search: val, page: 1 };
								setFilter(next);
								getProducts(next);
							}}
						/>

						<Dropdown trigger={['click']} dropdownRender={() => filterDropdown}>
							<Button>
								<Space>
									<FilterOutlined />
									Lọc
								</Space>
							</Button>
						</Dropdown>
					</Flex>
				)}
			/>

			<Table
				rowKey={(record) => record?._id || record?.id}
				pagination={{
					current: filter.page,
					pageSize: filter.limit,
					total: total,
					onChange: handlePageChange,
					showSizeChanger: true,
				}}
				className="mt-2"
				loading={loading}
				columns={columns}
				dataSource={products}
				scroll={{ x: 1300 }}
			/>

			<TV_page_detail
				ref={refDetail}
				getProducts={getProducts}
				categories={dictionary?.categories}
				colors={dictionary.colors}
			/>

			{/* drawer quản lý section */}
			<PageSectionLinkPremium ref={refLink} />
		</>
	);
};

export default TV_page;
